var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.99 26.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #1a1818;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    className: "cls-2",
    x1: 5.94,
    y1: 7.21,
    x2: 21.05,
    y2: 7.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    className: "cls-2",
    x1: 5.94,
    y1: 11.21,
    x2: 21.05,
    y2: 11.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8434",
    className: "cls-1",
    d: "M23.4.5H3.59c-1.7,0-3.08,1.38-3.09,3.08,0,0,0,0,0,0v11.15c0,1.7,1.37,3.08,3.07,3.09,0,0,0,0,.01,0h3.61v8.1l8.1-8.1h8.11c1.7,0,3.08-1.38,3.09-3.08,0,0,0,0,0,0V3.59c0-1.7-1.38-3.08-3.08-3.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.2597e43d5a0f0da65b92f7277273aa8e.svg";
export { ForwardRef as ReactComponent };